<template>
  <div class="niste-clan">
    <div>Niste član ovog projekta. Javite se voditelju da vam omogući pristup.</div>
    <router-link to="/projects">Povrat na popis</router-link>
  </div>
</template>

<script>
export default {
    

}
</script>

<style>

</style>